import "./index.css";
import { Controller, useFormContext } from "react-hook-form";
import Input from "../input";
import { FormInputs } from "./index.types";

export function FormInput({ name, isRequired, error, defaultValue, ...rest }: FormInputs) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        ...(isRequired
          ? {
              required: (error?.message as any) || "Field is required",
            }
          : {}),
      }}
      render={({ field, fieldState: { error } }) => {
        return (
          <Input
            isRequired
            error={{
              is: !!error,
              message: error?.message,
            }}
            defaultValue={defaultValue}
            {...field}
            {...rest}
          />
        );
      }}
    />
  );
}

export default FormInput;
